export const CDN_ENDPOINT = 'https://d2refp30laz1gf.cloudfront.net'

// ['testnet', 'mainnet']
export const DEFAULT_NETWORK = process.env.REACT_APP_DEFAULT_NETWORK

export const TRADING_VIEW_CHART_API_ENDPOINT_MAP = {
  mainnet: 'https://api.orderly.org/tv',
  testnet: 'https://testnet-api.orderly.org/tv'
}

export const API_ENDPOINT_MAP = {
  mainnet: {
    public: 'wss://ws.orderly.org/ws/stream',
    private: 'wss://ws-private.orderly.org/v2/ws/private/stream'
  },
  testnet: {
    public: 'wss://testnet-ws.orderly.org/ws/stream',
    private: 'wss://testnet-ws-private.orderly.org/v2/ws/private/stream'
  }
}

export const CONTRACT_MAP = {
  mainnet: 'asset-manager.orderly-network.near',
  testnet: 'asset-manager.orderly.testnet'
}

export const ASSET_MANAGER_CONTRACT_METHOD_NAMES = [
  'user_announce_key',
  'user_request_set_trading_key',
  'create_user_account'
]

export const BLOCK_EXPLORER_URL_MAP = {
  mainnet: 'https://explorer.near.org',
  testnet: 'https://explorer.testnet.near.org'
}

export const DEFAULT_MARKET_SYMBOL = 'PERP_BTC_USDC'

export const DEFAULT_ROUTE_MAP = {
  trade: `/trade/${DEFAULT_MARKET_SYMBOL}`,
  walletHistory: '/wallet/history/deposit'
}

export const LOCAL_STORAGE_KEYCHAIN = 'keychain'

export const LOCAL_STORAGE_CONFIG_KEY = 'userConfig'

export const BROKER_ID = 'btse_dex'

export const WALLET_KEY_STORE_PREFIX_MAP = {
  'meteor-wallet': '_meteor_wallet'
}

export const MIN_NEAR_WALLET_BALANCE = 0.06
